var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 260",
    preserveAspectRatio: "xMidYMax meet",
    role: "img",
    "aria-label": "Foto de perfil pendiente",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa-bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f1a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#111111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa-fg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#11b36d",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#11b36d",
    stopOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 260,
    fill: "url(#pa-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#pa-fg)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 98,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 260c0-42 32-70 72-70s72 28 72 70z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAvatar);
export default __webpack_public_path__ + "static/media/placeholder-avatar.a402583ea6c449c8c60c8a5e4216d052.svg";
export { ForwardRef as ReactComponent };